import { FC } from "react";
import { AccountingMigrationExternalSystem } from "@common/types/domains/accounting/accountingMigration";
import {
    InstitutionIcon,
    type InstitutionKey,
} from "@design-system/InstitutionIcon/InstitutionIcon";
import { AccountingIcon } from "@icons";

export const OTHER_EXTERNAL_SYSTEM = "other";

export type ExternalSystemChoice =
    | AccountingMigrationExternalSystem
    | typeof OTHER_EXTERNAL_SYSTEM;

export interface ExternalSystemOption {
    system: AccountingMigrationExternalSystem | null;
    institution?: InstitutionKey;
}

export const EXTERNAL_SYSTEM_OPTIONS: ExternalSystemOption[] = [
    {
        system: AccountingMigrationExternalSystem.QUICKBOOKS_ONLINE,
        institution: "quickbooks",
    },
    {
        system: AccountingMigrationExternalSystem.QUICKBOOKS_ONLINE_GL_COA,
        institution: "quickbooks",
    },
    {
        system: AccountingMigrationExternalSystem.QUICKBOOKS_DESKTOP,
        institution: "quickbooks",
    },
    {
        system: AccountingMigrationExternalSystem.INTUIT_ENTERPRISE_SUITE,
        institution: "quickbooks",
    },
    { system: AccountingMigrationExternalSystem.XERO, institution: "xero" },
    { system: AccountingMigrationExternalSystem.DIGITS, institution: "digits" },
    { system: AccountingMigrationExternalSystem.PUZZLE, institution: "puzzle" },
    { system: AccountingMigrationExternalSystem.BENCH, institution: "bench" },
    { system: null },
];

export const PICKABLE_EXTERNAL_SYSTEM_OPTIONS = EXTERNAL_SYSTEM_OPTIONS.filter(
    (option) =>
        option.system !==
        AccountingMigrationExternalSystem.QUICKBOOKS_ONLINE_GL_COA,
);

export const getExternalSystemLabel = (
    system: AccountingMigrationExternalSystem | null,
): string => system ?? "Other";

export const toExternalSystemChoice = (
    system: AccountingMigrationExternalSystem | null,
): ExternalSystemChoice => system ?? OTHER_EXTERNAL_SYSTEM;

export const ExternalSystemIcon: FC<{ institution?: InstitutionKey }> = ({
    institution,
}) =>
    institution ? (
        <InstitutionIcon institution={institution} size="xs" />
    ) : (
        <InstitutionIcon size="xs" fallback={<AccountingIcon />} />
    );
